import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query TipoProducto {
            TYPES {
              TipoProducto {
                readAll {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
        variables: {},
      })
      .then((result) => result.data.data.TYPES.TipoProducto.readAll),
};
